<template comments>
  <div v-if="show" class="mwe-popbox">
    <div class="mwe-popbox-dialog">
      <div class="mwe-popbox-inner">
        <div class="mwe-popbox-hd">
          <h3 class="mwe-popbox-tit">
            <slot name="title"></slot>
          </h3>
        </div>
        <div class="mwe-popbox-cont">
          <slot></slot>
        </div>
        <div v-if="this.$slots.button" class="mwe-popbox-ft">
          <slot name="button"></slot>
        </div>
      </div>
      <div v-if="!this.$slots.button" class="mwe-popbox-extra">
        <!-- 取消按钮 S  -->
        <a class="mwe-popbox-qclose" @click="close">
          <span class="mwe-popbox-qclose-ico"></span>
        </a>
        <!-- 取消按钮 E  -->
      </div>
    </div>
    <div class="mwe-mask" @click="close"></div>
  </div>
</template>

<script>
import { dialogNoScroll } from '@/libs/utils';
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(value) {
      dialogNoScroll(value);
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    }
  }
};
</script>
